import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import SvgIcon from "@mui/material/SvgIcon";
import Tooltip from "@mui/material/Tooltip";
import React, { useContext, useState } from "react";
import { InfoCircle } from "react-bootstrap-icons";
import { DashboardContext } from "../../../DashboardContext/DashboardContextProvider";
import { FormContext } from "../context/FormProvider";
import * as Messages from "../messages/messages";
import "./styles/list-checkboxes.css";

const ListCheckboxes = ({
  label,
  idProp,
  state,
  setState,
  val,
  debouncedSave,
  setIsLoading,
  disabledInput,
}) => {
  const [open, setOpen] = useState(false);

  const { userId } = useContext(DashboardContext);
  const { handleInputDisable } = useContext(FormContext);

  const handleCheckboxChange = (e) => {
    let newState = {
      ...state,
      [idProp]: !state[idProp],
    };

    if (
      newState[idProp] === true &&
      (idProp === "noiRequest" ||
        idProp === "notPreparationRequest" ||
        idProp === "lvvChecklistRequest" ||
        idProp === "swpppPreparationRequest" ||
        idProp === "swpppInspectionRequest" ||
        idProp === "postingNoticeSignRequest" ||
        idProp === "bmpInstallationRequest" ||
        idProp === "bmpMaintenanceRequest")
    ) {
      newState["swpppServicesRequest"] = "Yes";
    }

    setState(newState);

    if (debouncedSave && setIsLoading) {
      setIsLoading(true);
      debouncedSave.mutate(newState);
    }
  };
  return (
    <div className="checkbox-info-container">
      <div className="checkbox-form-container">
        <FormControlLabel
          disabled={
            handleInputDisable(idProp, state, disabledInput, userId) === true
              ? true
              : false
          }
          control={
            <Checkbox
              checked={val}
              icon={
                <div id="checkbox-container">
                  <SvgIcon
                    component={CheckBoxOutlineBlankIcon}
                    className="checkbox-icon"
                    viewBox="3 3 18 18"
                  />
                </div>
              }
              checkedIcon={
                <div id="checkbox-container">
                  <SvgIcon
                    component={CheckBoxIcon}
                    className="checkbox-icon"
                    id="checked-icon"
                    viewBox="3 3 18 18"
                  />
                </div>
              }
              className="list-checkbox"
            />
          }
          label={label}
          classes={{
            label: "checkbox-label",
            root: "checkbox-label-root",
          }}
          onChange={handleCheckboxChange}
          labelPlacement="end"
        />
      </div>
      <Tooltip
        id="rf-tooltip"
        classes={{
          tooltip: "radio-field-tooltip",
          popper: "radio-field-popper",
          arrow: "radio-field-arrow",
          tooltipPlacementRight: "radio-field-right",
          tooltipPlacementBottom: "radio-field-bottom",
        }}
        title={Messages[`${idProp}Message`] || ""}
        open={open}
        arrow
        placement={"top"}
      >
        <InfoCircle
          className="text-info-circ"
          id={`info-projectType`}
          color="white"
          size={30}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        />
      </Tooltip>
    </div>
  );
};

export default ListCheckboxes;
